<template>
  <div class="info">
    <Season />
    <MouseControl style="margin-left: 32px" />
    <KeyboardControl style="margin-left: 32px" />
    <SensorControl style="margin-left: 32px" />
  </div>
</template>

<style lang="scss">
.info {
  display: flex;
  margin-top: 24px;

  width: max-content;
  margin-left: auto;
  margin-right: auto;
}
</style>

<script>
import KeyboardControl from "./KeyboardControl.vue";
import MouseControl from "./MouseControl.vue";
import Season from "./Season.vue";
import SensorControl from "./SensorControl.vue";

export default {
  name: "Info",
  components: { Season, MouseControl, KeyboardControl, SensorControl },
};
</script>
